import * as actionTypes from "./CustomerFeedbackTypes";

const INITIAL_STATE = {
	feedbackFormData: null,
	ticketFeedback: null,
};

const customerFeedbackReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case actionTypes.SET_FEEDBACK_FORM_DATA:
			return {
				...state,
				feedbackFormData: action.payload,
			};
		case actionTypes.SET_TICKET_FEEDBACK:
			return {
				...state,
				ticketFeedback: action.payload,
			};
		default:
			return state;
	}
};

export default customerFeedbackReducer;
